// AccessReqsStep.js
import React from 'react';
import NetworkLoadBalancerInfo from '../NetworkLoadBalancerInfo';
import ApplicationLoadBalancerInfo from '../ApplicationLoadBalancerInfo';

function AccessReqsStep({ state, setState }) {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Access Requirements</h2>
        <p className="text-gray-600 mb-6">Select your access and load balancing requirements</p>
      </div>
      <div className="space-y-4">
        {/* Private NLB */}
        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="checkbox"
              checked={state.privateNlb}
              onChange={e => setState(prev => ({ ...prev, privateNlb: e.target.checked }))}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Private Network Load Balancer</span>
              <span className="block text-sm text-gray-500">Required for inbound sFTP, SSH and TCP access from within your private network</span>
            </span>
          </label>
          <NetworkLoadBalancerInfo type="private" />
        </div>

        {/* Public NLB */}
        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="checkbox"
              checked={state.publicNlb}
              onChange={e => setState(prev => ({ ...prev, publicNlb: e.target.checked }))}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Internet Facing Network Load Balancer</span>
              <span className="block text-sm text-gray-500">Required for inbound sFTP, SSH and TCP access from the internet</span>
            </span>
          </label>
          <NetworkLoadBalancerInfo type="public" />
        </div>

        {/* Private ALB */}
        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="checkbox"
              checked={state.privateAlb}
              onChange={e => setState(prev => ({ ...prev, privateAlb: e.target.checked }))}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Private Application Load Balancer</span>
              <span className="block text-sm text-gray-500">Required for Web, SOAP and API access from within your private network</span>
            </span>
          </label>
          <ApplicationLoadBalancerInfo type="private" />
        </div>

        {/* Public ALB */}
        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="checkbox"
              checked={state.publicAlb}
              onChange={e => setState(prev => ({ ...prev, publicAlb: e.target.checked }))}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Internet Facing Application Load Balancer</span>
              <span className="block text-sm text-gray-500">Required for Web, SOAP and API access from the internet</span>
            </span>
          </label>
          <ApplicationLoadBalancerInfo type="public" />
        </div>
      </div>
    </div>
  );
}


export default AccessReqsStep;